import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { ScanService } from 'src/app/services/scan.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-hidden-menu',
  templateUrl: './hidden-menu.component.html',
  styleUrls: ['./hidden-menu.component.scss']
})
export class HiddenMenuComponent implements OnInit {

  static readonly PW = 'dtactp2';

  constructor(private authorziationService: AuthorizationService, private userService: UserService, private scanService: ScanService) { }

  ngOnInit(): void {
  }


  navigate(role: string, mask: string) {
    this.userService.logout();
    this.userService.login({ text: '', username: role, password: HiddenMenuComponent.PW }).subscribe(() => {
      this.scanService.setMask(mask);
    });
  }
}
